// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
    activeLoadPreviousPage: true,
    paginationType: 'infinite',
    positionShowInfiniteLoading: 700,
/* Optional */
		// loadProductFirst: true,
	}
};

// Declare Templates
var bcSfFilterTemplate = {
	'soldOutClass': 'sold-out',
	'saleClass': 'on-sale',
	'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
	'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
	'vendorHtml': '<div>{{itemVendorLabel}}</div>',

	// Grid Template
	'productGridItemHtml':
    `<div class="collection-product column xsmall-medium--6 large--4 {{bundleClass}}" data-ease-in>
      <div class="hover-area relative {{soldOutClass}} {{saleClass}}{{hoverClass}}" data-collection-product="{{itemId}}">
        <a href="{{itemUrl}}" title="{{itemTitle}}" class="block no-decoration relative">
          <div class="background-image" data-ratio="1:1"{{itemThumbUrl}}>
            {{itemThumbImg}}
          </div>

          {{itemSecondaryThumb}}
          <!-- include "wishlist-button-collection" with "{{itemId}}" -->
        </a>
        {{itemFlag}}
        <div class="card-content padding-3x xsmall-medium--padding-left-0x xsmall-medium--padding-right-0x background--background foreground--text">
          <div class="card-content__header margin-bottom-3x">
            <a href="{{itemUrl}}" class="block no-decoration foreground--text foreground--hover-text">
              <p class="h5 text-uppercase line-height-1-5x xsmall-medium--hide margin-bottom-1x">
                <strong>{{itemTitle}}</strong>
              </p>
              <p class="h5 text-uppercase line-height-1-5x large--hide">
                <strong>{{itemTitle}}</strong>
              </p>
            </a>
            {{itemSelect}}
            <div class="hide" data-product-json>{{itemJson}}</div>
            <div class="hover-content xsmall-medium--hide margin-bottom-1x">
              <!-- Color Swatches -->
              {{colorSwatches}}
            </div>
          </div>
          <div class="card-content__footer">
            <div class="card-content__price">
              <div>
                {{itemPriceMobile}}
              </div>

              <div class="row flush vertical-center margin-bottom-1x">
                <div class="column medium-xlarge--12 text-center small--text-left hover-opacity">
                  <div class="yotpo bottomLine"
                    data-appkey="tM79B0rNMkMLR0ObUjMasPwEy5heDLrZjdedgrKb"
                    data-domain="mineral-fusion-us.myshopify.com"
                    data-product-id="{{itemId}}"
                    data-product-models="{{itemId}}"
                    data-name="{{itemTitle}}"
                    data-url="{{itemUrl}}"
                    data-image-url="{{itemImageUrl}}"
                    data-description="{{itemDescription}}"
                    data-bread-crumbs="{{itemTags}}">
                  </div>
                </div>
              </div>
            </div>
            {{itemBtn}}
            {{itemButtonMobile}}
          </div>
        </div>
      </div>
     </div>
  {[itemPromo1]}
  {[itemPromo2]}
  {[itemPromo3]}
`,

	// Pagination Template
	'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
	'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
	'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
	'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
	'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
	'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
	'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

	// Sorting Template
	'sortingHtml': '{{sortingItems}}',
	// 'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

function BCSfFilterCallback(a) {
  document.dispatchEvent(new Event('bcs:product-inserted'));

  bcsffilter.afterGetFilterData(a,a.event_type);
}

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
/** Get SEO information we attached previously to document */
	const {productsSEOInfo} = document;

/*** Prepare data ***/
	var images = data.images_info;
	data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	var isPalette = data.template_suffix === 'palette'; // Check a product is palette
	var isBundle = data.product_type === 'Bundle'; // Check a product is bundle
	var tags = data.tags

	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function(e) {
			return e.id == getParam('variant');
		});
		if (typeof paramVariant[0] !== 'undefined')
			firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
/*** End Prepare data ***/

	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;

	// Add JSON
	var self = this;
	var itemJson = {
		"id": data.id,
		"title": data.title,
		"handle": data.handle,
		"vendor": data.vendor,
		"variants": data.variants,
		"url": self.buildProductItemUrl(data),
		"options_with_values": data.options_with_values,
		"images": data.images,
		"available": data.available,
		"price_min": data.price_min,
		"price_max": data.price_max,
		"compare_at_price_min": data.compare_at_price_min,
		"compare_at_price_max": data.compare_at_price_max
	};
	itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

	// Add Default Select
	var itemSelect = '';
	itemSelect += '<select class="hide" data-product-select>';
	for (var k in data.variants) {
		var variant = data['variants'][k];
		var selectedAttr = variant['id'] == firstVariant['id'] ? 'selected="selected"' : '';
		var disabledAttr = !variant.available ? ' disabled="disabled"' : '';
		itemSelect += '<option ' + selectedAttr + disabledAttr + ' value="' + variant.id + '">' + variant.title + '</option>';
	}
	itemSelect += '</select>';

	itemHtml = itemHtml.replace(/{{itemSelect}}/g, itemSelect);

	// Add Promo Banner
	var promo1 = bcSfFilterConfig.custom.promo1;
	var promo2 = bcSfFilterConfig.custom.promo2;
	var promo3 = bcSfFilterConfig.custom.promo3;
	var currentPage = this.queryParams.page;

	if (index == 2 && currentPage < 2) {
		itemHtml = itemHtml.replace(/{\[itemPromo1\]}/g, promo1);
	} else {
		itemHtml = itemHtml.replace(/{\[itemPromo1\]}/g, '');
	}

	if (index == 5 && currentPage < 2) {
		itemHtml = itemHtml.replace(/{\[itemPromo2\]}/g, promo2);
	} else {
		itemHtml = itemHtml.replace(/{\[itemPromo2\]}/g, '');
	}

	if (index == 8 && currentPage < 2) {
		itemHtml = itemHtml.replace(/{\[itemPromo3\]}/g, promo3);
	} else {
		itemHtml = itemHtml.replace(/{\[itemPromo3\]}/g, '');
	}

	// Add Thumbnail
	var itemImageUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : null;
	var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : null;

	if (itemThumbUrl != null) {
		itemHtml = itemHtml.replace(/{{itemImageUrl}}/g, itemThumbUrl);
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, ' style="background-image:url(' + itemThumbUrl + ')"');
		itemHtml = itemHtml.replace(/{{itemThumbImg}}/g, '<img src="' + itemThumbUrl + '" alt="{{itemTitle}}" />');
	} else {
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, '');
		itemHtml = itemHtml.replace(/{{itemThumbImg}}/g, '');
	}

	if (images.length > 1) {
		var itemSecondaryThumbUrl = images.length > 0 ? this.optimizeImage(images[1]['src']) : bcSfFilterConfig.general.no_image_url;
		var itemSecondaryThumb = '<div class="background-image secondary-image" data-ratio="1:1" style="background-image:url({{itemSecondaryThumbUrl}})"><img src="{{itemSecondaryThumbUrl}}" alt="{{itemTitle}}" /></div>';
		itemSecondaryThumb = itemSecondaryThumb.replace(/{{itemSecondaryThumbUrl}}/g, itemSecondaryThumbUrl);
		itemHtml = itemHtml.replace(/{{itemSecondaryThumb}}/g, itemSecondaryThumb);
		itemHtml = itemHtml.replace(/{{hoverClass}}/g, ' has-secondary-image');
	} else {
		itemHtml = itemHtml.replace(/{{itemSecondaryThumb}}/g, '');
		itemHtml = itemHtml.replace(/{{hoverClass}}/g, '');
	}

	// Add Tags
	var itemTags = ''

	if (tags.length > 1) {
		for (i = 0; i < tags.length; i++) {
			itemTags += tags[i] + ';'
		}
		itemHtml = itemHtml.replace(/{{itemTags}}/g, itemTags);
	}

	// Add Hover State
	var hover = '';
	var defaultValue = false;
	var disabled = '';
	var productClass = '';
	var productbutton = '';
	var defaultValue = defaultValue ? data.variants[0].id : '';

	for (var i in data.options) {
		if ((data['options'][i].indexOf('title') >= 0) || (data.variants.length < 2)) {
			defaultValue = true;
		} else {
			var hover = '';
		}
	}

	// Add correct disabled state
	if (!data.available) {
		var disabled = ' disabled';
		var productClass = 'hide';
	} else if (!defaultValue) {
		var productClass = 'hide';
	} else if (isPalette) {
    var productClass = 'hide';
  } else {
		var productbutton = 'hide';
	}

	// Add Price
  let itemPriceHtml = '';
	if (data.title != '') {
		itemPriceHtml += '<p class="grid-link__meta">';
		if (onSale) {
			itemPriceHtml += '<s class="grid-link__sale_price">' + this.formatMoney(data.compare_at_price_min / 100) + '</s> ';
		}
		if (priceVaries) {
			// itemPriceHtml += (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min));
    } else {
			itemPriceHtml += this.formatMoney(data.price_min / 100);
		}

		itemPriceHtml += '</p>';
	}

  var btnText = '';
  var itemBtnHtml = '';

	if (productClass === 'hide' && firstVariant.available && !isPalette && !isBundle) {
		btnText = 'Select Shade';
	} else if (isPalette) {
    btnText = bcSfFilterConfig.label.add_palette_to_cart;
	} else if (isBundle) {
    btnText = bcSfFilterConfig.label_basic.view_more_label;
  } else {
		btnText = firstVariant.available ? bcSfFilterConfig.label.add_to_cart : bcSfFilterConfig.label.sold_out;
	}

  let comparePrice = this.formatMoney(data.compare_at_price_min / 100);
  let originalPrice = this.formatMoney(data.price_min / 100);

  if(isPalette) {
    comparePrice = this.formatMoney(bcSfFilterConfig.label.add_palette_to_cart_amount);
    originalPrice = this.formatMoney(bcSfFilterConfig.label.add_palette_to_cart_amount);
  }

	//var btnText = firstVariant.available ? bcSfFilterConfig.label.add_to_cart : bcSfFilterConfig.label.sold_out;
	var onSaleClass = onSale ? ' ' : 'class="hide"';
	var bundleClass = data.product_type == 'Bundle' ? 'BundlePage' : ''

  itemHtml = itemHtml.replace(/{{bundleClass}}/g, bundleClass);

  const btnAttrs = (!isPalette && !isBundle) ? `data-add-to-cart-button data-quick-add="${firstVariant['id']}"` : '';

  if (data.product_type != 'Bundle') {

    itemBtnHtml += `
      <button class="margin-bottom-2x button secondary wide xsmall-medium--hide ${productClass}" ${btnAttrs} ${disabled}>
        <div class="button-group">
          <span data-add-to-cart-text>${btnText}</span>
          <s data-compare-price ${onSaleClass}>${comparePrice}</s>
          <span data-product-price class="money" data-price-wrapper>${originalPrice}</span>
        </div>
      </button>`;
    //itemBtnHtml += ' <button class="margin-bottom-2x button secondary wide xsmall-medium--hide" data-add-to-cart-button data-quick-add="" ' + disabled + '>';

    itemBtnHtml += `
      <a href="{{itemUrl}}" class="no-decoration">
        <button class="margin-bottom-2x button secondary wide xsmall-medium--hide ${productbutton}" data-add-to-cart-button data-add-product="${data.id}" ${disabled}>
          <div class="button-group">
            <span data-add-to-cart-text>${btnText}</span>
            <s data-compare-price ${onSaleClass}>${comparePrice}</s>
            <span data-product-price class="money" data-price-wrapper>${originalPrice}</span>
          </div>
        </button>
      </a>`;
    //itemBtnHtml += ' <button class="margin-bottom-2x button secondary wide xsmall-medium--hide" data-add-to-cart-button data-quick-add="" ' + disabled + '>';
  } else {
    itemBtnHtml = `
      <a href="{{itemUrl}}">
        <button class="margin-bottom-2x button secondary wide">
          <span data-add-to-cart-text>${theme.strings.learnMore}</span>
        </button>
      </a>`;
  }

	itemHtml = itemHtml.replace(/{{itemBtn}}/g, itemBtnHtml);

	var itemButtonMobile = '';
  if (data.product_type != 'Bundle') {
    itemButtonMobile += `
      <button class="margin-bottom-1x button secondary wide large--hide ${productClass}" data-add-to-cart-button data-quick-add="${firstVariant['id']}" ${disabled}>
        <span data-add-to-cart-text>${btnText}</span>
      </button>
      <a href="{{itemUrl}}" class="no-decoration">
        <button class="margin-bottom-1x button secondary wide large--hide ${productbutton}" data-add-to-cart-button data-add-product="${data.id}" ${disabled}>
          <span data-add-to-cart-text>${btnText}</span>
        </button>
      </a>`;
  }
	itemHtml = itemHtml.replace(/{{itemButtonMobile}}/g, itemButtonMobile);

	var itemPriceMobileHtml = '';
	var priceMobile = originalPrice;
	var comparePriceMobile = comparePrice;
	itemPriceMobileHtml += `
    <div class="margin-bottom-2x large--hide">
      <s data-compare-price ${onSaleClass}>${comparePriceMobile}</s>
      <span class="inline">${priceMobile}</span>
    </div>`;
	itemHtml = itemHtml.replace(/{{itemPriceMobile}}/g, itemPriceMobileHtml);
	//console.log('priceMobile', priceMobile, 'comparePriceMobile', comparePriceMobile);

	// Add errors
	var itemErrorHtml = '';
	itemErrorHtml += '<p data-error="'+data.id+'" class="hide font-size-tiny foreground--error">' + bcSfFilterConfig.label.select_an_option + '</p>';
	itemHtml = itemHtml.replace(/{{itemError}}/g, itemErrorHtml);

	// Add soldOut class
	var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
	itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

	// Add onSale class
	var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
	itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

	// Add soldOut label
	var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
	itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

	// Add onSale label
	var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
	itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

	// Add flag label
	itemHtml = itemHtml.replace(/{{itemFlag}}/g, this.buildFlag(data));

	for (var k in data.variants) {
		var variant = data['variants'][k];
	}

	// Add Vendor
	var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

	// Note we are getting the item description form the SEO information.
	const productId =data.id;
	const productSEOInfo = productsSEOInfo[productId]
	const itemDescription = productSEOInfo.description_tag ? productSEOInfo.description_tag: "";

	// console.log({productId, productsSEOInfo, productSEOInfo, itemDescription})

	itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
	itemHtml = itemHtml.replace(/{{itemVariants}}/g, this.buildVariants(data));
	//Replace HTML
	itemHtml = itemHtml.replace(/{{colorSwatches}}/g, this.buildColorSwatches(data));

	return itemHtml;
};


//Builds Color Swatchse On Collections Page - Brandon
BCSfFilter.prototype.buildColorSwatches = function(data) {
	//Retrieves Result From Template-Collection.Liquid
	const variantColors = document.variantColors;
	//Add Item Form
	var html = '';
	//If Product Has More Then One Length
	if (data.variants.length > 1) {
		//Iterate through product variants
		for (var val in data.variants) {
			const variant = data.variants[val];

			if (variantColors[variant.id]) {
				const { productHandle, hexcode, image } = variantColors[variant.id]


				const getUrl = window.location;
				const baseUrl = getUrl .protocol + "//" + getUrl.host; // eg. "https://mineral-fusion-us.myshopify.com/"

				const variantLink = `${baseUrl}/products/${productHandle}?variant=${variant.id}`;


				if (image) {
					html += `<a href=${variantLink}><button id=colorSwatchButton style= background:url(${image});></button></a>`;
				} else if (hexcode) {
					html +=  `<a href=${variantLink}><button id=colorSwatchButton style= background:${hexcode};></button></a>`;
				}

			}

		}
	}
	//Returns html
	return html;
}

window.onload = function() {
  document.dispatchEvent(new Event('bcs:product-inserted'));
};


// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {};
//Remove Options
BCSfFilter.prototype.buildVariants = function(data) {
	// Add Item Form
	var html = '';
	html += '<div class="variant-options margin-bottom-1x">';

	for (var i in data.options_with_values) {
		var option = data['options_with_values'][i];
		optionIndex = ++i;

		if ((option.name.indexOf('title') < 0) && (data.variants.length > 1)) {
			if ((data.options_with_values.length == 1) && (option.values.length <= 3)) {
				for (var val in option.values) {
					var value = option.values[val];
					html += '<div class="variant-option">';
					html += '<input id="product_' + data.id + '_option_' + optionIndex + '_value_' + value.title.replace(/ /g, '-') + '" type="radio" name="product_' + data.id + '_option_' + optionIndex + '" value="' + value.title + '" data-single-option-selector data-index="option' + optionIndex + '">';
					html += '<label for="product_' + data.id + '_option_' + optionIndex + '_value_' + value.title.replace(/ /g, '-') + '" data-close data-target="#t_' + new Date().getTime() + '_product_' + data.id + '_option_' + optionIndex + '" class="toggle text-uppercase">' + value.title + '</label>';
					html += '</div>';
				}
			} else {
				html += '<div class="variant-option variant-option--dropdown">';
				html += '<div id="t_' + new Date().getTime() + '_product_' + data.id + '_option_' + optionIndex + '" class="dropdown-wrapper dropdown-full">';
				html += '<div class="dropdown-trigger" data-trigger="dropdown" data-target="#t_' + new Date().getTime() + '_product_' + data.id + '_option_' + optionIndex + '">' + bcSfFilterConfig.icons.down_arrow + '</div>';
				html += '<div class="dropdown-options text-center">';
				html += '<input id="product_' + data.id + '_option_' + optionIndex + '_value_default" type="radio" name="product_' + data.id + '_option_' + optionIndex + '" value=""  data-single-option-selector data-index="option' + optionIndex + '" disabled checked>';
				html += '<label for="product_' + data.id + '_option_' + optionIndex + '_value_default" data-close data-target="#t_' + new Date().getTime() + '_product_' + data.id + '_option_' + optionIndex + '" class="text-uppercase">' + option.name + '</label>';

				for (var val in option.values) {
					var value = option.values[val];
					html += '<input id="product_' + data.id + '_option_' + optionIndex + '_value_' + value.title.replace(/ /g, '-') + '" type="radio" name="product_' + data.id + '_option_' + optionIndex + '" value="' + value.title + '" data-single-option-selector data-index="option' + optionIndex + '">';
					html += '<label for="product_' + data.id + '_option_' + optionIndex + '_value_' + value.title.replace(/ /g, '-') + '" data-close data-target="#t_' + new Date().getTime() + '_product_' + data.id + '_option_' + optionIndex + '" class="toggle text-uppercase">' + value.title + '</label>';
				}
				html += ' </div>';
				html += ' </div>';
				html += ' </div>';
			}
		}
	}
	html += ' </div>';

	return html;
};

BCSfFilter.prototype.buildFlag = function(data) {
	var html = '';
	var flagLabel = false;
	var flagTitle = '';

	for (var i = 0; i < data['tags'].length; i++) {
		var tagHandle = data['tags'][i].toLowerCase();
		if (tagHandle.match("^flag")) {
			flagTitle = tagHandle.split('flag:');
			flagLabel = true;
		}
	}

	if (flagLabel) {
		html = '<p class="label">' + flagTitle[1] + '</p>';
	}
	return html;
}

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
	if (this.getSettingValue('general.paginationType') == 'default') {
		// Get page info
		var currentPage = parseInt(this.queryParams.page);
		var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

		// If it has only one page, clear Pagination
		if (totalPage == 1) {
			jQ(this.selector.bottomPagination).html('');
			return false;
		}

		if (this.getSettingValue('general.paginationType') == 'default') {
			var paginationHtml = bcSfFilterTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			jQ(this.selector.bottomPagination).html(paginationHtml);
		}
	}
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content
			var sortingItemsHtml = '';

			var sortingItemsHtmlDesktop = '<button class="inline button medium secondary dropdown dropdown-auto hover margin-left-1x small--wide">';
			var sortingItemsHtmlMobile = '<button class="dropdown-trigger medium inline button secondary  dropdown hover margin-left-1x wide">';
			sortingItemsHtml += '<div class="dropdown-label vertical-middle text-none">' + bcSfFilterConfig.icons.down_arrow_small + '<span>Sort by</span></div>';
			sortingItemsHtml += '<div class="dropdown-content"><div class="dropdown-content-area dropdown-content-area-expanded"><ul>';

			for (var k in sortingArr) {
				var activeClass = (this.queryParams.sort == k) ? 'selected' : '';
				sortingItemsHtml += '<li><p class="line-height-1x letter-spacing-0x text-none text-left">' +
				'<a class="foreground--text foreground--hover-alternate" href="javascript:void(0);" data-value="' + k + '" title="' + sortingArr[k] + '" aria-label="' + sortingArr[k] + '" data-sort="created-descending">' + sortingArr[k] + '</a>' +
				'</p></li>';
			}
			sortingItemsHtml += '</ul></div></div></button>';

			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);

			jQ(this.selector.topSorting).html(sortingItemsHtmlDesktop + html);
			jQ('#bc-sf-filter-bottom-sorting').html(sortingItemsHtmlMobile + html);
			return html;
		}
	}
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
	var _this = this;
	var ob = this.getSelector('topSorting') + ' a';
	jQ('body').on('click', ob, function(e) {
		onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('value'));
	});
	var obottom = '#bc-sf-filter-bottom-sorting a';
	jQ('body').on('click', obottom, function(e) {
		onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('value'));
	});
};

/************************** END BUILD TOOLBAR **************************/

// Build Default layout
function buildDefaultLink(a, b)
{
	var c = window.location.href.split("?")[0];
	return c += "?" + a + "=" + b
}
BCSfFilter.prototype.buildDefaultElements = function(a) {
	if (bcSfFilterConfig.general.hasOwnProperty("collection_count") && jQ("#bc-sf-filter-bottom-pagination").length > 0) {
		var b = bcSfFilterConfig.general.collection_count,
		c = parseInt(this.queryParams.page),
		d = Math.ceil(b / this.queryParams.limit);
		if (1 == d)
			return jQ(this.selector.pagination).html(""), !1;
		if ("default" == this.getSettingValue("general.paginationType")) {
			var e = bcSfFilterTemplate.paginateHtml,
			f = "";
			f = c > 1 ? bcSfFilterTemplate.hasOwnProperty("previousActiveHtml") ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousHtml : bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml") ? bcSfFilterTemplate.previousDisabledHtml : "", f = f.replace(/{{itemUrl}}/g, buildDefaultLink("page", c - 1)), e = e.replace(/{{previous}}/g, f);
			var g = "";
			g = c < d ? bcSfFilterTemplate.hasOwnProperty("nextActiveHtml") ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextHtml : bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml") ? bcSfFilterTemplate.nextDisabledHtml : "", g = g.replace(/{{itemUrl}}/g, buildDefaultLink("page", c + 1)), e = e.replace(/{{next}}/g, g);
			for (var h = [], i = c - 1; i > c - 3 && i > 0; i--)
				h.unshift(i);
			c - 4 > 0 && h.unshift("..."), c - 4 >= 0 && h.unshift(1), h.push(c);
			for (var j = [], k = c + 1; k < c + 3 && k <= d; k++)
				j.push(k);
			c + 3 < d && j.push("..."), c + 3 <= d && j.push(d);
			for (var l = "", m = h.concat(j), n = 0; n < m.length; n++)
				"..." == m[n] ? l += bcSfFilterTemplate.pageItemRemainHtml : l += m[n] == c ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml, l = l.replace(/{{itemTitle}}/g, m[n]), l = l.replace(/{{itemUrl}}/g, buildDefaultLink("page", m[n]));
			e = e.replace(/{{pageItems}}/g, l), jQ(this.selector.pagination).html(e)
		}
	}
	if (bcSfFilterTemplate.hasOwnProperty("sortingHtml") && jQ(this.selector.topSorting).length > 0) {
		jQ(this.selector.topSorting).html("");
		var o = this.getSortingList();
		if (o) {
			var p = "";
			for (var q in o)
				p += '<option value="' + q + '">' + o[q] + "</option>";
			var r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p);
			jQ(this.selector.topSorting).html(r);
			var s = void 0 !== this.queryParams.sort_by ? this.queryParams.sort_by : this.defaultSorting;
			jQ(this.selector.topSorting + " select").val(s), jQ(this.selector.topSorting + " select").change(function(a) {
				window.location.href = buildDefaultLink("sort_by", jQ(this).val())
			})
		}
	}
};

// Customize data to suit the data of Shopify API

BCSfFilter.prototype.prepareProductData = function(data) {
	data = this.filterProducts(data);

	for (var k = 0; k < data.length; k++) {
		data[k]['images'] = data[k]['images_info'];
		if (data[k]['images'].length > 0) {
			data[k]['featured_image'] = data[k]['images'][0]
		} else {
			data[k]['featured_image'] = {
				src: bcSfFilterConfig.general.no_image_url,
				width: '',
				height: '',
				aspect_ratio: 0
			}
		}
		data[k]['url'] = '/products/' + data[k].handle;
		var optionsArr = [];
		for (var i = 0; i < data[k]['options_with_values'].length; i++) {
			optionsArr.push(data[k]['options_with_values'][i]['name'])
		}
		data[k]['options'] = optionsArr;
		data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;
		data[k]['price'] = data[k]['price_min'];
		data[k]['compare_at_price'] = data[k]['compare_at_price_min'];
		data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];

		var firstVariant = data[k]['variants'][0];
		if (getParam('variant') !== null && getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == getParam('variant')
			});
			if (typeof paramVariant[0] !== 'undefined')
				firstVariant = paramVariant[0]
		} else {
			for (var i = 0; i < data[k]['variants'].length; i++) {
				if (data[k]['variants'][i].available) {
					firstVariant = data[k]['variants'][i];
					break
				}
			}
		}
		data[k]['selected_or_first_available_variant'] = firstVariant;
		for (var i = 0; i < data[k]['variants'].length; i++) {
			var variantOptionArr = [];
			var count = 1;
			var variant = data[k]['variants'][i];
			var variantOptions = variant['merged_options'];
			if (Array.isArray(variantOptions)) {
				for (var j = 0; j < variantOptions.length; j++) {
					var temp = variantOptions[j].split(':');
					data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
					data[k]['variants'][i]['option_' + temp[0]] = temp[1];
					variantOptionArr.push(temp[1])
				}
				data[k]['variants'][i]['options'] = variantOptionArr
			}
			data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
			data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100
		}
		data[k]['description'] = data[k]['content'] = data[k]['body_html']
	}

	return data;
};

// Add additional feature for product list, used commonly in customizing product list
//BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
//if (typeof window.refeshOkendo === 'function') {
//  window.refeshOkendo();
//}
//};

// Filter out sample and free gifts
BCSfFilter.prototype.filterProducts = function(data) {
	return data;
	//   return data.filter(product => !product.tags.includes("freegift"));
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
	var filteredProducts = this.filterProducts(data.products);

	if (data.total_product > 1) {
		jQ('.bc-sf-search-result-number').html(data.total_product + ' Items');
	} else {
		jQ('.bc-sf-search-result-number').html(data.total_product + ' Item');
	}

  yotpoInit();

	var lazyTrigger = new Event('lazy:reload');
	document.dispatchEvent(lazyTrigger);

	var cardTrigger = new Event('cards:resize');
	document.dispatchEvent(cardTrigger);

	var easeTrigger = new Event('ease:update');
	document.dispatchEvent(easeTrigger);

	var productsTrigger = new Event('collection:productsAdded');
	document.dispatchEvent(productsTrigger);

	var currencyTrigger = new Event('currency:convert');
	document.dispatchEvent(currencyTrigger);

	var selectsTrigger = new Event('selects:update');
	document.dispatchEvent(selectsTrigger);

	var compareUpdate = new Event('compare:update');
	document.dispatchEvent(compareUpdate);

	setTimeout(function() {
		var easeTrigger = new Event('ease:update');
		document.dispatchEvent(easeTrigger);
	}, 1000);

	jQ('body').on('click', '.bc-sf-filter-block-title', function(event) {
		jQ('#bc-sf-filter-tree').addClass('is-left');
		jQ(this).parent().find('.bc-sf-filter-block-content').addClass('is-active');
	});

	var mobileFilter = '';
	mobileFilter += '<ul class="filter-options-list">';

	jQ('#bc-sf-filter-options-wrapper .bc-sf-filter-option-block').each(function() {
		mobileFilter += '<li class="bc-sf-filter-block-title"><a data-item-filter-trigger="' + $(this).data('block-id') + '">';
		mobileFilter += jQ(this).find('.bc-sf-filter-block-title').html();
		mobileFilter += '</a></li>';
	});
	mobileFilter += '</ul>';
	//jQ('#bc-sf-filter-tree-mobile').html(mobileFilter);
	jQ('#bc-sf-filter-tree #bc-sf-filter-options-wrapper').prepend(mobileFilter);
};

function yotpoInit(attemptCounter = 10) {
  if(typeof Yotpo === 'function' && attemptCounter > 0) {
    const api = new Yotpo.API(yotpo);
    if(typeof api === 'object') {
      api.refreshWidgets();
      console.log('Yotpo reviews reinit: ' + attemptCounter)
    }
  } else {
    setTimeout(function() {
      yotpoInit(--attemptCounter);
    }, 300);
  }
}

jQ('body').on('click', '[data-item-filter-trigger]', function() {
	var Id = jQ(this).data('item-filter-trigger');
	var itemIndex = jQ(this).parent().index() + 1;
	jQ(this).parent().parent().addClass('invisible');
	jQ('#bc-sf-filter-tree [data-block-id="' + Id + '"]').addClass('visible');
	setTimeout(function() {
		jQ('#bc-sf-filter-tree').addClass('visible-tree child' + itemIndex);
	}, 600);
});

jQ('body').on('click', '.bc-sf-filter-option-block .bc-sf-filter-block-title', function(e) {
	e.stopPropagation();
	var itemIndex = jQ(this).parent().index();
	jQ(this).parent().removeClass('visible');
	jQ('#bc-sf-filter-tree').removeClass('visible-tree child' + itemIndex);
	jQ('#bc-sf-filter-tree .filter-options-list').removeClass('invisible');
});

jQ('body').on('click', '[data-close-mobile-filter]', function() {
	jQ('[data-filter-options]').slideUp(200);
	setTimeout(function() {
		jQ('#bc-sf-filter-tree').removeClass('visible-tree');
		jQ('#bc-sf-filter-tree .filter-options-list').removeClass('invisible');
		jQ('#bc-sf-filter-tree [data-block-id]').removeClass('visible');
	}, 300);
});

//window.okeReviewsWidgetOnInit = function (okeInitApi) {
//  var writeReviewButton = document.querySelector('.js-okeReviews-writeReview');
//  var checkLoop = setInterval(function() {
//    var navbar = document.querySelector('.okeReviews-widgetNavBar');
//    if (navbar) {
//      if (writeReviewButton) {
//        navbar.append(writeReviewButton);
//      }
//      clearInterval(checkLoop);
//    }
//  }, 100);

//  window.refeshOkendo =  function () {
//    okeInitApi.initCoreWidgets()
//  };
//}
window.onload = function() {
	var api = new Yotpo.API(yotpo);
	api.refreshWidgets(); // 4th
};

jQ('body').on('click', '#bc-sf-filter-load-more-button-container', function() {
	var api = new Yotpo.API(yotpo);
	setTimeout(function() {
		api.refreshWidgets(); // 4th
	}, 300);
});

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version)
{
	var self = bcsffilter;
	var ext = typeof ext !== 'undefined' ? ext : 'png';
	var version = typeof version !== 'undefined' ? version : '1';
	var prIndex = self.fileUrl.lastIndexOf('?');
	if (prIndex > 0) {
		var filePath = self.fileUrl.substring(0, prIndex);
	} else {
		var filePath = self.fileUrl;
	}
	filePath += fileName + '.' + ext + '?v=' + version;
	return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType, errorCount) {function BCSend(eventType, errorCount)
	{
		var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();
		if (typeof self.buildPlaceholderProductList=="function") {
			self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e) {
			if (typeof document.getElementById(script.id).remove=="function") {
				document.getElementById(script.id).remove()} else {
				document.getElementById(script.id).outerHTML=""}
			if (errorCount<3) {
				errorCount++;
				if (resendAPITimer) {
					clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)} else {
				self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function() {
			if (typeof document.getElementById(script.id).remove=="function") {
				document.getElementById(script.id).remove()} else {
				document.getElementById(script.id).outerHTML=""}}
	}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc, eventType, errorCount) {sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html, iLabel, iValue, fOType, fOId, fOLabel, fODisplayType, fOSelectType, fOItemValue, fOData) {var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;
	if (fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text") {
		var title=this.getReviewRatingsLabel(fOItemValue.from)} else {
		var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}
	if (keepValuesStatic===true)
		var productNumber=null; else
		var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});
	if (fOType!="collection") {
		htmlElement.children().attr("rel","nofollow")}
	if (fOType=="collection")
		htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function() {return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function() {
	try {
		var t=decodeURIComponent(window.location.search).split("&"),e=!1;
		if (t.length>0)
			for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;
			if (a>0&&r>0||a>1||r>1||o||h) {
				e=!0;break}}return e} catch (l) {
		return!0}};
/* End patch boost-010 run 2 */
